<template>
    <div id="alert-banners" />
</template>

<script>
import { startExistFunction } from 'utils/startExistFunction';

export default {
    mounted() {
        startExistFunction('initBannerReact', 50, 'alert-banners');
    },

    beforeUnmount() {
        startExistFunction('resetBannerReact', 50);
    },
};
</script>
